import React, { useState, useEffect } from "react";
import { Check, ArrowRight, Heart, Footprints, Landmark } from "lucide-react";
import { api } from "../lib/api";
import { useI18n } from "../i18n/I18nContext";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import BookingDialog from "../components/BookingDialog";
import EngagementBadges from "../components/EngagementBadges";

const IMAGES = [
  "https://images.unsplash.com/photo-1519756719377-e084f8333a83?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  "https://images.unsplash.com/photo-1775438817482-dcb8b581cf70?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  "https://images.unsplash.com/photo-1560087389-660db08335c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
];
const ICONS = [Heart, Footprints, Landmark];

export default function PackagesPage() {
  const { t } = useI18n();
  const items = t("packages.items");
  const [acc, setAcc] = useState([]);
  const [booking, setBooking] = useState(false);
  const [pkgName, setPkgName] = useState(null);

  useEffect(() => { api.get("/accommodations").then((r) => setAcc(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageHero
        title={t("packages.title")}
        subtitle={t("packages.subtitle")}
        image={IMAGES[2]}
        crumb={t("nav.sejours")}
      />

      <section className="py-14 lg:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid md:grid-cols-3 gap-8">
          {items.map((p, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={i} delay={i * 120}>
                <article className="group h-full flex flex-col bg-white rounded-2xl overflow-hidden border border-black/5 shadow-[0_8px_32px_rgba(44,48,48,0.06)]" data-testid={`package-card-${i}`}>
                  <div className="relative aspect-[4/3] overflow-hidden">
                    <img src={IMAGES[i % IMAGES.length]} alt={p.title} loading="lazy" className="img-zoom w-full h-full object-cover" />
                    <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-white/95 text-brand px-3 py-1.5 text-xs font-medium">
                      <Icon size={14} /> {t("packages.from")} 100 €
                    </span>
                  </div>
                  <div className="p-7 flex flex-col flex-1">
                    <h3 className="font-heading text-2xl text-ink-900 mb-1">{p.title}</h3>
                    <p className="text-ink-600 font-body text-sm mb-5">{p.tagline}</p>
                    <p className="text-xs font-semibold text-ink-700 mb-2">{t("packages.included")}</p>
                    <ul className="space-y-2 mb-6 text-sm text-ink-600">
                      {p.includes.map((it) => (
                        <li key={it} className="flex items-start gap-2"><Check size={16} className="text-brand mt-0.5 shrink-0" />{it}</li>
                      ))}
                    </ul>
                    <button type="button" onClick={() => { setPkgName(p.title); setBooking(true); }} data-testid={`package-book-${i}`} className="mt-auto inline-flex items-center justify-center gap-2 rounded-full bg-brand text-white px-6 py-3 font-medium hover:bg-brand-600 transition-colors">
                      {t("packages.cta")} <ArrowRight size={17} />
                    </button>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </section>

      <EngagementBadges />

      <BookingDialog accommodations={acc} packageName={pkgName} open={booking} onOpenChange={setBooking} />
    </div>
  );
}
